import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { Observable,BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityService {

  constructor(public apiService: ApiService) { }

  private matTraArr = new BehaviorSubject({});
 
  currentMatTraArr = this.matTraArr.asObservable(); 
  
  currentMatTraArray(data: any){
    this.matTraArr.next(data)
  }

  private matTraData = new BehaviorSubject({});
 
  currentMatTraData = this.matTraData.asObservable(); 
  
  currentMatTra(data: any){
    this.matTraData.next(data)
  }

  // private matTraArr = new BehaviorSubject({});
 
  // currentMatTraArr = this.matTraArr.asObservable(); 
  
  // currentMatTraArray(data: any){
  //   console.log(data)
  //   this.matTraArr.next(data)
  // }

  private prodTraData = new BehaviorSubject({});
 
  currentProdTraData = this.prodTraData.asObservable(); 
  
  currentProdTra(data: any){
    console.log(data)
    this.prodTraData.next(data)
  }

  getRecLotByRecLotId(body : any): Observable<any> {
    return this.apiService.get('traceability/getRecLotByRecLotId/'+body.company_id+'/'+body.rec_lot_id)
  }
  getMLCByInternalCode(body : any): Observable<any> {
    return this.apiService.get('traceability/getMLCByInternalCode/'+body.company_id+'/'+body.rec_lot_id)
  }
  getRecLotByMaterialId(body : any): Observable<any> {
    return this.apiService.get('traceability/getRecLotByMaterialId/'+body.material_id+'/'+body.start_date+'/'+body.end_date+'/'+body.page_no)
  }
  getMLCsByFormulaId(body : any): Observable<any> {
    return this.apiService.get('traceability/getMLCsByFormulaId/'+body.product_id+'/'+body.start_date+'/'+body.end_date)
  }
  getMaterialTraceability(body : any): Observable<any> {
    return this.apiService.get('traceability/getMaterialTraceability/'+body.id+'/'+body.mat_id+'/'+body.company_id)
  }
  getProductTraceability(body : any): Observable<any> {
    return this.apiService.get('traceability/getProductTraceability/'+body.mlc_id+'/'+body.product_id)
  }
  
}
